import { hostConfigs } from '~/utils/config';
import utils from '~/utils/index';

export default function (context) {
  const { req } = context;
  const [, prefix] = process.server ? req.url.split('/') : window.location.pathname.split('/');
  const userAgent = process.server ? context.req.headers['user-agent'] : window.navigator.userAgent;
  let layoutType = '';
  switch (prefix) {
    case 'webDemoCenter':
      layoutType = 'demo';
      break;
    case 'sdkDemoCenter':
      layoutType = 'sdkDemo';
      break;
    case 'news':
      layoutType = 'news';
      break;
    case 'demoList':
      layoutType = 'demo';
      break;
    default:
      layoutType = 'doc';
      break;
  }
  context.host = process.server ? req.headers.host : window.location.host;
  let findedConfig = hostConfigs.find(config => config.hosts.indexOf(context.host) !== -1);
  if (!findedConfig) {
    [findedConfig] = hostConfigs;
  }

  if (utils.isIE(userAgent)) { // 由于统计组件ie兼容问题，如果是ie浏览器则不引入统计组件
    const scripts = [...findedConfig[layoutType].script];
    const index = scripts.findIndex(script => script.name === 'statistic');
    index !== -1 && scripts.splice(index, 1);
    context.script = scripts;
  } else {
    context.script = findedConfig[layoutType].script;
  }
  context.navInit = findedConfig[layoutType].callback;
  context.sidebarOpenedDepth = findedConfig[layoutType].sidebarOpenedDepth || 0;
  context.showFeedback = findedConfig.showFeedback;
  context.appkey = findedConfig.appkey;
  context.userAgent = userAgent;
};
